import { MasterButton, Modal } from "App/Component/ui"
import { Grid } from "@material-ui/core"
import React, { useContext } from "react"
import ModalListKunjungan from "./ModalListKunjungan"
import { FormContext } from "../../../../context/FormContext"
import ModalListPenjualan from "./ModalDaftarPenjualan"
import { RESET_STATE_INPUT_PENJUALAN } from "../../../helpers"
import useMutationDiskon from "../../../hooks/useMutationDiskon"

const ModalMuat = ({
  setShowModal,
  showModalListKunjungan,
  setShowModalListKunjungan,
  showModalListPenjualan,
  setShowModalListPenjualan,
}) => {
  const { formData, setFormData } = useContext(FormContext)
  const { getDiskon, isLoading } = useMutationDiskon()

  const handleClickSelect = async (row) => {
    const disc = await getDiskon(row.id_type_of_care, row.insurance_id)

    setFormData({
      ...RESET_STATE_INPUT_PENJUALAN,
      id_type_of_care: row.id_type_of_care,
      penjualan_id: "",
      tagihan_id: row.tagihan_id,
      kunjungan_id: row.id,
      jenis_layanan_id: row.jenis_layanan_id,
      jenis_layanan_name: row.layanan_name,
      asuransi_id: row.insurance_id,
      asuransi: row.insurance_name,
      noasuransi: row.insurance_no,
      rm_id: row.patients_id,
      // tax_percent: row.tax,
      // pembayaran: row.bayar_jual,
      // potongan: row.jumlah_set_discount,
      dokter_id: row.doctor_id,
      dokter_name: row.doctor_name,
      nama: row.isexternalrm ? row.rm_name_external : row.rm_name,
      kelas_id: row.kelaskunjungan_id === 0 ? 3 : row.kelaskunjungan_id,
      kelas_name:
        row.kelaskunjungan_id === 0 ? "Kelas 3" : row.kelaskunjungan_name,
      barang: [],
      rikjang: [],
      paket: [],
      jasa: [],
      fasilitas: [],

      diskon: disc,
    })
    setShowModalListKunjungan(false)
    setShowModal(false)
  }

  return (
    <>
      {showModalListKunjungan && (
        <ModalListKunjungan
          setShowModal={setShowModalListKunjungan}
          setModalParent={setShowModal}
          handleClickSelect={handleClickSelect}
          isLoadingDiskon={isLoading}
        />
      )}

      {showModalListPenjualan && (
        <ModalListPenjualan
          setShowModal={setShowModalListPenjualan}
          setModalParent={setShowModal}
        />
      )}

      <div
        style={{
          display: `${
            showModalListKunjungan || showModalListPenjualan ? "none" : "block"
          }`,
        }}
      >
        <Modal title={"Muat"} show={() => setShowModal(false)}>
          <Grid container direction="row" alignItems="center">
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"submit"}
              color="green"
              name="BARU DARI KUNJUNGAN"
              onClick={() => {
                setShowModalListKunjungan(!showModalListKunjungan)
              }}
              size="lg"
            />
            <MasterButton
              onClick={() => {
                setShowModalListPenjualan(!showModalListPenjualan)
              }}
              className={"mt-1 w-full text-center"}
              type={"submit"}
              color="green"
              outline={true}
              name="EDIT PENJUALAN"
              size="lg"
            />
          </Grid>
        </Modal>
      </div>
    </>
  )
}

export default ModalMuat
